module.exports = __webpack_public_path__ + "static/img/智慧网银云4.cddd442d.png";